import { render, staticRenderFns } from "./PhoneLinkCompass.vue?vue&type=template&id=c6f15146&"
import script from "./PhoneLinkCompass.vue?vue&type=script&lang=js&"
export * from "./PhoneLinkCompass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports